module.exports = __webpack_public_path__ + "components/flag/static/square/cn-814b7a346be4f0b26b4a1547b9eee4bd.svg";